<template>
  <el-button type="primary" size="mini" icon="el-icon-download" style="margin-right: 10px" @click="downloadExcel">导出考勤表</el-button>
  <!-- <el-button type="info" size="mini" icon="el-icon-download" >下载</el-button> -->
</template>

<script>
import ExportJsonExcel from 'js-export-excel'
export default {
  name: 'ExportExcel',
  props: {
    info: ''
  },
  data() {
    return {}
  },
  computed: {
    errorLogs() {
      // return this.$store.getters.errorLogs
      // this.$store.dispatch('errorLog/clearErrorLog')
    }
  },
  mounted() {},
  methods: {
    downloadExcel() {
      // this.$http.post
      console.log(this.info, 'info')
      const data = this.info ? this.info : '' // 表格数据
      var option = {}
      const dataTable = []
      if (data) {
        for (const i in data) {
          if (data) {
            const obj = {
              企业名称: data[i].company.companyName,
              职位: data[i].company.zhiwei,
              联系方式: data[i].company.contact,
              真实姓名: data[i].company.name,
              打卡记录1: `第一次：${data[i].time1 || ''} ${data[i].punchStatus1 == 0 ? '正常' : data[i].punchStatus1 == 1 ? '外勤' : '缺卡'} ${
                data[i].punchType1 == 0 ? '出勤打卡' : data[i].punchType1 == 1 ? '外勤打卡' : '未打卡'
              }`,
              打卡记录2: `第二次：${data[i].time2 || ''} ${data[i].punchStatus2 == 0 ? '正常' : data[i].punchStatus2 == 1 ? '外勤' : '缺卡'} ${
                data[i].punchType2 == 0 ? '出勤打卡' : data[i].punchType2 == 1 ? '外勤打卡' : '未打卡'
              }`,
              打卡定位地理1: data[i].poiAddress1,
              打卡定位地理2: data[i].poiAddress2,
              打卡照片1: data[i].onPunchImageUrl1,
              打卡照片2: data[i].onPunchImageUrl2,
              备注1: data[i].remark1,
              备注2: data[i].remark2,
              打卡日期: data[i].punchDate,
              账号: data[i].company.username
            }
            dataTable.push(obj)
          }
        }
      }
      option.fileName = '打卡记录'
      option.datas = [
        {
          sheetData: dataTable,
          sheetName: 'sheet',
          sheetFilter: [
            '企业名称',
            '职位',
            '联系方式',
            '真实姓名',
            '打卡记录1',
            '打卡记录2',
            '打卡定位地理1',
            '打卡定位地理2',
            '打卡照片1',
            '打卡照片2',
            '备注1',
            '备注2',
            '打卡日期',
            '账号'
          ],
          sheetHeader: [
            '企业名称',
            '职位',
            '联系方式',
            '真实姓名',
            '打卡记录1',
            '打卡记录2',
            '打卡定位地理1',
            '打卡定位地理2',
            '打卡照片1',
            '打卡照片2',
            '备注1',
            '备注2',
            '打卡日期',
            '账号'
          ],
          columnWidths: ['15', '5', '5', '6', '18', '18', '18', '18', '18', '18', '6', '6', '6', '6']
        }
      ]
      var toExcel = new ExportJsonExcel(option)
      toExcel.saveExcel()
    }
  }
}
</script>

<style scoped></style>
